import type { LayoutLoad } from "./$types";
import { loadCommunity } from "./load";

// disable across community - only enable ssr on a per-page basis
export const ssr = false;

/** Load community data */
export const load: LayoutLoad = (event) => loadCommunity(event);
